// makes a call to the flickr API, retrieving one page of results

// eslint-disable-next-line
const log = function (message) {
  if (process.env.NODE_ENV === "development") {
    //console.log(message); // uncomment to show logs from this component
  }
};

const imagesPerPage = 400; // 60 = Google image search; 500 = max. for flickr

const flickrRestCall = async function (page) {
  // this function handles the call the flickr
  let url = new URL("https://api.flickr.com/services/rest");
  let params = {
    // https://www.flickr.com/services/api/flickr.photos.search.html
    method: "flickr.photos.search",
    tags: "vizbi",
    sort: "date-taken-asc",
    api_key: "1f76f84d4503878c5dbc2b472c469cba", // config.api_key
    format: "json",
    extras: "url_n, url_l, url_o, owner_name, date_taken",
    page: page,
    per_page: imagesPerPage,
    nojsoncallback: 1,
  };
  // https://stackoverflow.com/q/37230555
  url.search = new URLSearchParams(params).toString();
  log(`url = ${url}`);
  try {
    const response = await fetch(url);
    if (!response.ok) {
      // https://dmitripavlutin.com/javascript-fetch-async-await/
      throw new Error("Fetch error " + response.status);
    }
    let responseJson = await response.json(); // critical: wait for json
    //log(`responseJson = ${stringify(responseJson)}`);
    return responseJson;
  } catch (error) {
    console.error(`Problem accessing flickr API: ${error}`);
  }
};

import {processFlickrSearchData} from "@/composables/useFlickrSearchData";
import {getFullstackUrl} from "@/composables/useFullstackUrl";

const FULLSTACK = getFullstackUrl();

// each year's photo count, newest first: {years: [{year, count}], total}
export async function fetchFlickrSummary() {
  try {
    const response = await fetch(`${FULLSTACK}/api/v1/flickr/photos?summary=1`);
    if (!response.ok) throw new Error("Fetch error " + response.status);
    return await response.json();
  } catch (error) {
    console.error(`Error fetching the flickr summary: `, error);
  }
}

// one year's photos (its taken-date range in Unix seconds, as the fullstack's summary counts it)
export async function fetchFlickrYear(year) {
  const minDate = Date.UTC(Number(year), 0, 1) / 1000;
  const maxDate = Date.UTC(Number(year) + 1, 0, 1) / 1000 - 1;
  return await fetchFlickrPhotos(minDate, maxDate);
}

export async function fetchFlickrPhotos(minDate, maxDate) {
  try {
    const raw = {};
    if (minDate != null) raw.minDate = minDate;
    if (maxDate != null) raw.maxDate = maxDate;
    const query = new URLSearchParams(raw).toString();
    const url = query ? `${FULLSTACK}/api/v1/flickr/photos?${query}` : `${FULLSTACK}/api/v1/flickr/photos`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Fetch error " + response.status);
    const {photos} = await response.json();
    const output = processFlickrSearchData(photos);
    output.photosTotal = photos.length;
    return output;
  } catch (error) {
    console.error(`Error fetching flickr photos: `, error);
  }
}

export async function fetchFlickrPage(page) {
  // this function handles states within this vue components
  try {
    let response = await flickrRestCall(page);
    if (!response) {
      return console.error(`No response from flickr API.`);
    }
    //log(`response = ${stringify(response)}`);
    let newPhotoData = await response.photos.photo;
    let output = processFlickrSearchData(newPhotoData);
    output.pagesTotal = await response.photos.pages;
    output.photosTotal = newPhotoData.length;
    log(`Fetched photo data page ${page}`);
    log(`Number of photos: ${output.photosTotal}`);
    return output;
  } catch (error) {
    console.error(`Error fetching flickr page ${page}: `, error);
  }
}
